import React, { useContext } from 'react';
import { MobileContext } from '@wix/da-shared-react/pkg/Context';
import { getPagingMode } from '@wix/da-shared-react/pkg/publicSession';
import { useSelector } from 'react-redux';
import FolderPagedContent from './FolderPagedContent';
import FolderInfiniteContent from './FolderInfiniteContent';

export interface Props {
  folderId: number;
}
const FolderContent: React.FC<Props> = ({ folderId }) => {
  const pagingMode = useSelector(state => getPagingMode(state));
  const isMobile = useContext(MobileContext);
  if (!isMobile && pagingMode === 'page') {
    return <FolderPagedContent folderId={folderId} />;
  }
  return <FolderInfiniteContent folderId={folderId} />;
};

export default FolderContent;
